/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} SamplesInputs */

const en_samples = /** @type {(inputs: SamplesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Samples`)
};

const es_samples = /** @type {(inputs: SamplesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muestras`)
};

/**
* | output |
* | --- |
* | "Samples" |
*
* @param {SamplesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const samples = /** @type {((inputs?: SamplesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<SamplesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_samples(inputs)
	return es_samples(inputs)
});